import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Dialog,Stack 
} from "@mui/material";
import { useParams , useNavigate } from "react-router-dom";
import { db, storage } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useLocation } from "react-router-dom";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { isBoxAccount } from "./utils/userProfile";
const CompareBoards = () => {
  const { orderId } = useParams();
  const username = localStorage.getItem("username");
  const isBaneen = username === "Baneen@123";
const navigate = useNavigate();
const location = useLocation();
const params = new URLSearchParams(location.search);
const fromApproval = params.get("from") === "approval";
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
const handleDeleteImage = async (fieldName, imageUrl) => {
  if (!window.confirm("هل تريد حذف هذه الصورة؟")) return;

  try {
    setLoading(true);

    const currentBoards = (order && order.compareBoards) || {};
    const updatedArr = normalizeArray(currentBoards[fieldName]).filter(
      (url) => url !== imageUrl
    );

    const res = await apiFetch(`${API_BASE}/orders/${orderId}/compare-boards`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fieldName, images: updatedArr }),
    });
    if (!res.ok) throw new Error(await res.text().catch(() => ""));

    await fetchOrder();
  } catch (err) {
    console.error(err);
    alert("حدث خطأ أثناء الحذف");
  } finally {
    setLoading(false);
  }
};
const handleReplaceImage = async (fieldName, oldUrl, file) => {
  try {
    setLoading(true);

    const fileId = `${Date.now()}_${file.name}`;
    const storageRef = ref(
      storage,
      `compareBoards/${orderId}/${fieldName}/${fileId}`
    );

    await uploadBytes(storageRef, file);
    const newUrl = await getDownloadURL(storageRef);

    const currentBoards = order.compareBoards || {};
    const updatedArr = normalizeArray(currentBoards[fieldName]).map((url) =>
      url === oldUrl ? newUrl : url
    );

    const res = await apiFetch(`${API_BASE}/orders/${orderId}/compare-boards`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fieldName, images: updatedArr }),
    });
    if (!res.ok) throw new Error(await res.text().catch(() => ""));

    await fetchOrder();
  } catch (err) {
    console.error(err);
    alert("حدث خطأ أثناء الاستبدال");
  } finally {
    setLoading(false);
  }
};

  // 🖼️ Popup لعرض الصورة المكبرة
  const [previewImage, setPreviewImage] = useState(null);

  // صلاحيات الرفع
  const canUploadSent =
    username === "rand@123" || username === "jumana@123" || username === "sara@123" || username === "Baneen@123" || username === "maryam@123"  || username === "karina@123" || username === "farah@123" || username === "maysa@123" || isBoxAccount();
  const canUploadPrinted = username === "designer@123" ;
  const canUploadDrawing = username === "halima@123" || username === "mohamed@123"
  ;
const canUploadPrintedBoard =
  (!order?.withDrawing && username === "Baneen@123") ||
  (order?.withDrawing && (username === "halima@123" || username === "mohamed@123"));
  const normalizeArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  const fetchOrder = async () => {
    try {
      if (orderId.startsWith("temp")) {
        setOrder({ compareBoards: {} });
        return;
      }

      const refDoc = doc(db, "orders", orderId);
      const snap = await getDoc(refDoc);

      if (snap.exists()) {
        setOrder(snap.data());
      } else {
        setOrder({ compareBoards: {} });
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      setOrder({ compareBoards: {} });
    }
  };

  const handleUpload = async (event, fieldName) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    try {
      setLoading(true);

      const uploadedUrls = [];
      for (const file of files) {
        const fileId = `${Date.now()}_${file.name}`;
        const storageRef = ref(
          storage,
          `compareBoards/${orderId}/${fieldName}/${fileId}`
        );
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        uploadedUrls.push(url);
      }

      if (orderId.startsWith("temp")) {
        const key = `compare_temp_${orderId}`;
        const existing = JSON.parse(localStorage.getItem(key) || "{}");
        const existingArr = normalizeArray(existing[fieldName]);
        const updatedArr = [...existingArr, ...uploadedUrls];
        existing[fieldName] = updatedArr;
        localStorage.setItem(key, JSON.stringify(existing));
      } else {
        const currentBoards = (order && order.compareBoards) || {};
        const existingArr = normalizeArray(currentBoards[fieldName]);
        const updatedArr = [...existingArr, ...uploadedUrls];

        const res = await apiFetch(`${API_BASE}/orders/${orderId}/compare-boards`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fieldName, images: updatedArr }),
        });
        if (!res.ok) throw new Error(await res.text().catch(() => ""));
      }

      event.target.value = "";
      await fetchOrder();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء رفع الصور");
    } finally {
      setLoading(false);
    }
  };

  if (!order) {
    return (
      <Box dir="rtl" sx={{ p: 3 }}>
        <Typography>جارِ التحميل...</Typography>
      </Box>
    );
  }

 const boards = orderId.startsWith("temp")
  ? JSON.parse(localStorage.getItem(`compare_temp_${orderId}`) || "{}")
  : order?.compareBoards || {};

// 🔥 الحل الحقيقي
const sentImages = normalizeArray(order?.compareBoards?.sentToCustomer);
  const printedImages = normalizeArray(boards.printedBoard);
  const drawingImages = normalizeArray(boards.drawingBoard);
const halimaPrintImages = normalizeArray(boards.halimaPrintedBoard);
const canUploadDrawingAfterPrint = halimaPrintImages.length > 0;

  const getMissingBoards = () => {
    const missing = [];
    if (sentImages.length === 0) missing.push("1️⃣ اللوحة الأصلية المرسلة إلى الزبون");
    if (printedImages.length === 0) missing.push("2️⃣ اللوحة بعد رفع الدقة والتعديل – المصمم");
    if (halimaPrintImages.length === 0) missing.push("3️⃣ اللوحة المطبوعة");
    if (order.withDrawing && drawingImages.length === 0) missing.push("4️⃣ اللوحة المرسومة");
    return missing;
  };

  const ensureAllBoardsUploaded = () => {
    const missing = getMissingBoards();
    if (missing.length > 0) {
      alert("⚠️ لا يمكن المتابعة قبل رفع صور المربعات التالية:\n\n" + missing.join("\n"));
      return false;
    }
    return true;
  };

  // ✅ كل مرحلة مسؤولة بس عن المربع الي من صلاحيتها ترفعه (نفس صلاحيات الرفع بالأعلى)
  const getMissingOwnBoards = () => {
    const missing = [];
    if (canUploadSent && sentImages.length === 0) missing.push("1️⃣ اللوحة الأصلية المرسلة إلى الزبون");
    if (canUploadPrinted && printedImages.length === 0) missing.push("2️⃣ اللوحة بعد رفع الدقة والتعديل – المصمم");
    if (canUploadPrintedBoard && halimaPrintImages.length === 0) missing.push("3️⃣ اللوحة المطبوعة");
    if (canUploadDrawing && order.withDrawing && drawingImages.length === 0) missing.push("4️⃣ اللوحة المرسومة");
    return missing;
  };

  const ensureOwnBoardUploaded = () => {
    const missing = getMissingOwnBoards();
    if (missing.length > 0) {
      alert("⚠️ لا يمكن المتابعة قبل رفع صور المربعات التالية:\n\n" + missing.join("\n"));
      return false;
    }
    return true;
  };

  // 🟦 عرض الصور بشكل احترافي + contain
const renderImages = (images, fieldName, canEdit) => (
  <Box
    sx={{
      maxHeight: 500,
      overflowY: "auto",
      p: 1,
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    {images.map((url, idx) => (
      <Paper
        key={idx}
        sx={{ p: 1, position: "relative", textAlign: "center" }}
      >
        <img
          src={url}
          alt="img"
          style={{
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
            cursor: "pointer",
          }}
          onClick={() => setPreviewImage(url)}
        />

        {canEdit && (
          <Box sx={{ display: "flex", gap: 1, mt: 1, justifyContent: "center" }}>
            {/* استبدال */}
            <Button variant="outlined" component="label" size="small">
              🔁 استبدال
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={(e) =>
                  handleReplaceImage(fieldName, url, e.target.files[0])
                }
              />
            </Button>

            {/* حذف */}
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => handleDeleteImage(fieldName, url)}
            >
              ❌ حذف
            </Button>
          </Box>
        )}
      </Paper>
    ))}
  </Box>
);

  return (
    <Box dir="rtl" sx={{ p: 3 }}>
  

      <Typography variant="h4" fontWeight="bold" sx={{ mb: 3 }}>
        مقارنة اللوحات
      </Typography>

      {loading && (
        <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={18} />
          <Typography fontSize={14}>جاري رفع الصور…</Typography>
        </Box>
      )}
<Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" },
    gap: 3,
  }}
>
  {/* 1️⃣ اللوحة الأصلية المرسلة إلى الزبون */}
  <Paper sx={{ p: 2, textAlign: "center" }}>
    <Typography fontWeight="bold">
      1️⃣ اللوحة الأصلية المرسلة إلى الزبون
    </Typography>

    {sentImages.length > 0
      ? renderImages(sentImages, "sentToCustomer", canUploadSent)
      : <Typography color="gray">لا توجد صور مرفوعة</Typography>}

    {canUploadSent && (
      <Button variant="contained" component="label" sx={{ mt: 2 }}>
        رفع صور
        <input
          hidden
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => handleUpload(e, "sentToCustomer")}
        />
      </Button>
    )}
  </Paper>

  {/* 2️⃣ اللوحة بعد رفع الدقة والتعديل - المصمم */}
  <Paper sx={{ p: 2, textAlign: "center" }}>
    <Typography fontWeight="bold">
      2️⃣ اللوحة بعد رفع الدقة والتعديل – المصمم
    </Typography>

    {printedImages.length > 0
      ? renderImages(printedImages, "printedBoard", canUploadPrinted)
      : <Typography color="gray">لا توجد صور مرفوعة</Typography>}

    {canUploadPrinted && (
      <Button variant="contained" component="label" sx={{ mt: 2 }}>
        رفع صور
        <input
          hidden
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => handleUpload(e, "printedBoard")}
        />
      </Button>
    )}
  </Paper>

  {/* 3️⃣ اللوحة المطبوعة */}
  <Paper sx={{ p: 2, textAlign: "center" }}>
    <Typography fontWeight="bold">
      3️⃣ اللوحة المطبوعة
    </Typography>

    {halimaPrintImages.length > 0
      ? renderImages(halimaPrintImages, "halimaPrintedBoard", canUploadPrintedBoard)
      : <Typography color="gray">لا توجد صور مرفوعة</Typography>}

{canUploadPrintedBoard && (      <Button variant="contained" component="label" sx={{ mt: 2 }}>
        رفع صور
        <input
          hidden
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => handleUpload(e, "halimaPrintedBoard")}
        />
      </Button>
    )}
  </Paper>

  {/* 4️⃣ اللوحة المرسومة */}
  {order.withDrawing && (
  <Paper sx={{ p: 2, textAlign: "center" }}>
    <Typography fontWeight="bold">
      4️⃣ اللوحة المرسومة
    </Typography>

    {drawingImages.length > 0
      ? renderImages(drawingImages, "drawingBoard", canUploadDrawing)
      : <Typography color="gray">لا توجد صور مرفوعة</Typography>}

{canUploadPrintedBoard && (  <>
    <Button
      variant="contained"
      component="label"
      sx={{ mt: 2 }}
      disabled={!canUploadDrawingAfterPrint}
    >
      رفع صور
      <input
        hidden
        type="file"
        multiple
        accept="image/*"
        onChange={(e) => {
          if (!canUploadDrawingAfterPrint) {
            alert("⚠️ يجب رفع اللوحة المطبوعة أولاً قبل رفع اللوحة المرسومة");
            return;
          }
          handleUpload(e, "drawingBoard");
        }}
      />
    </Button>

    {!canUploadDrawingAfterPrint && (
      <Typography color="error" fontSize={13} sx={{ mt: 1 }}>
        ⚠️ يجب رفع اللوحة المطبوعة أولاً
      </Typography>
    )}
  </>
)}

  </Paper>
  )}
</Box>

      {/* 🟦 Popup لعرض الصورة كاملة مع Scroll */}
      <Dialog
        open={!!previewImage}
        onClose={() => setPreviewImage(null)}
        maxWidth="md"
        fullWidth
      >
        <Box
          sx={{
            maxHeight: "90vh",
            overflowY: "auto",
            p: 2,
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#000",
          }}
        >
          <img
            src={previewImage}
            alt="preview"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>
      </Dialog>

      <Box sx={{ textAlign: "center", mt: 4 }}>
        {!isBaneen && (
     <Button
  variant="contained"
  color="success"
  sx={{ fontSize: "18px", px: 3, py: 1.5 }}
  onClick={() => {
    if (!ensureOwnBoardUploaded()) return;

    // نخلي المصمم يفتح البوب اب تلقائيًا
    localStorage.setItem("comparisonDone", "true");
    localStorage.setItem("comparisonOrderId", orderId);

    // رجوع مضمون لواجهة المصمم (designer)
    navigate(fromApproval ? "/approval" : -1);
  }}
>
  ✔️ إكمال المقارنة والعودة لإرسال الطلب
</Button>
)}
{isBaneen && (
  <Box sx={{ textAlign: "center", mt: 4 }}>
    <Stack direction="row" spacing={2} justifyContent="center">

      {/* زر موافق */}
      <Button
        variant="contained"
        color="success"
        sx={{ fontSize: "18px", px: 4 }}
        onClick={async () => {
        if (!ensureAllBoardsUploaded()) return;

        const res = await apiFetch(`${API_BASE}/orders/${orderId}/compare-approval`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ decision: "approve" }),
        });
        if (!res.ok) {
          console.error("خطأ أثناء تسجيل الموافقة:", await res.text().catch(() => ""));
          return;
        }

          navigate("/Baneen");
        }}
      >
        ✅ موافق
      </Button>

      {/* زر غير موافق */}
   <Button
  variant="contained"
  color="error"
  sx={{ fontSize: "18px", px: 4 }}
  onClick={async () => {
if (!ensureAllBoardsUploaded()) return;

const res = await apiFetch(`${API_BASE}/orders/${orderId}/compare-approval`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ decision: "reject" }),
});
if (!res.ok) {
  console.error("خطأ أثناء تسجيل الرفض:", await res.text().catch(() => ""));
  return;
}

    navigate("/Baneen");
  }}
>
  ❌ غير موافق
</Button>

    </Stack>
  </Box>
)}
      </Box>
    </Box>
  );
};

export default CompareBoards;
